import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { Form, Input, Modal } from 'antd'
import { userActions } from '../../store/actions/user'

const Login = ({ navigate }) => {
	const [isModalVisible, setIsModalVisible] = useState(false)
	const { loginLoading, user } = useSelector((state) => state.userReducer)
	const [form] = Form.useForm()
	const dispatch = useDispatch()
	const handleOk = () => {
		form.validateFields().then(values => {
			const {
				login,
				password
			} = values
			dispatch(userActions.login({
				login,
				password
			}, navigate))
		})
	}

	useEffect(() => {
		if (user.isLoggedIn) {
			setIsModalVisible(false)
		}
	}, [user.isLoggedIn])

	const handleCancel = () => {
		form.resetFields()
		setIsModalVisible(false)
	}

	return (
		<>
			<Link
				className="nav-link none-color-item-focus layout-header-submenu-menu-item"
				to="#"
				onClick={() => setIsModalVisible(true)}
			>
				Вход
			</Link>
			<Modal
				cancelText="Отмена"
				okButtonProps={{ loading: loginLoading }}
				okText="Вход"
				title="Вход в систему"
				open={isModalVisible}
				onCancel={handleCancel}
				onOk={handleOk}
			>
				<Form
					autoComplete="off"
					form={form}
					layout="vertical"
				>
					<Form.Item
						label="Логин"
						name="login"
						rules={[
							{
								required: true,
								message: "Введите имя пользователя"
							}
						]}
					>
						<Input autoComplete="new-password" />
					</Form.Item>
					<Form.Item
						label="Пароль"
						name="password"
						rules={[
							{
								required: true,
								message: "Введите пароль"
							}
						]}
					>
						<Input.Password
							autoComplete="new-password"
							onPressEnter={handleOk}
						/>
					</Form.Item>
				</Form>
			</Modal>
		</>
	)
}

export default Login